
import React from 'react'
import {Router, useRouterHistory} from 'dva/router'
import { createHashHistory } from 'history';
import { LocaleProvider } from 'antd';
import es_ES from 'antd/lib/locale-provider/es_ES';

import App from './components/app'
import Dashboard from './components/dashboard'
import Profile from './components/profile'

import Hotel from './components/hotels'
import HotelNew from './components/hotels/hotelNew'

import Provider from './components/providers'
import ProviderNew from './components/providers/providerNew'

import User from './components/users'
import UserNew from './components/users/userNew'

import Tour from './components/tours'

import Seller from './components/sellers'
import SellerNew from './components/sellers/sellerNew'

import Activity from './components/activities'
import CategoryActivity from './components/activities/categories'

export default function ({history}) {
    const routes = [
        {
            path: '/',
            component: App,
            getIndexRoute(nextState, cb) {
                require.ensure([], require => {
                    cb(null, {component: Dashboard})
                })
            },
            childRoutes: [
                {
                    path: '/hotels',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, Hotel)
                        })
                    }
                },
                {
                    path: '/hotels/new-hotel',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, HotelNew)
                        })
                    }
                },
                {
                    path: '/hotels/details/:hotelId',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, HotelNew)
                        })
                    }
                },
                {
                    path: '/all_users/list-providers',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, Provider)
                        })
                    }
                },
                {
                    path: '/providers/new-provider',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, ProviderNew)
                        })
                    }
                },
                {
                    path: '/providers/details/:providerId',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, ProviderNew)
                        })
                    }
                },
                {
                    path: '/all_users/list-sellers',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, Seller)
                        })
                    }
                },
                {
                    path: '/sellers/new-seller',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, SellerNew)
                        })
                    }
                },
                {
                    path: '/sellers/details/:sellerId',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, SellerNew)
                        })
                    }
                },
                {
                    path: '/all_users/list-users',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, User)
                        })
                    }
                },
                {
                    path: '/users/new-user',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, UserNew)
                        })
                    }
                },
                {
                    path: '/users/details/:userId',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, UserNew)
                        })
                    }
                },
                {
                    path: '/tours',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, Tour)
                        })
                    }
                },
                {
                    path: '/activities/list-activities',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, Activity)
                        })
                    }
                },
                {
                    path: '/activities/list-categories',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, CategoryActivity)
                        })
                    }
                },
                {
                    path: '/profile',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, Profile)
                        })
                    }
                }
            ]
        }
    ]

    const appHistory = useRouterHistory(createHashHistory)({ queryKey: false })
    return <LocaleProvider locale={es_ES}><Router history={appHistory} routes={routes} /></LocaleProvider>
}


// WEBPACK FOOTER //
// ./src/router.js